module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c97dc074c1b113aa15f766ee958ee8c9.png";